import { IndexedZipData } from 'components/patient/upsert/UpsertPatient';
import { FieldRenderProps } from 'react-final-form';
import { DropdownProps, Grid } from 'semantic-ui-react';
import styled from 'styled-components';
import { ZipDataOrderBy } from 'ts-types/api.enums';
import { UpsertPatientDto } from 'ts-types/api.types';
import { IndexSignature } from 'utils/praxTypes';
import { required } from 'utils/validatorUtils';

const CONDITIONAL_FIELDS: Array<string> = ["bname", "bfirstName", "bstreet", "bzip", "bcity", "bcountryId"];
const FIELDS: IndexSignature = {
  select: ["countryId", "civilStatus", "languageId", "language", "mandateId", "bcountryId", "representingDoctorId"],
  checkBox: ["active", "separateBill", "reminder"],
  radioButton: ["sex", "bsex"],
  datePicker: ["birthDate", "dateOfDeath"]
};

export const VALIDATED_FIELDS: Array<string> = [
  "name", "firstName", "street", "zip",
  "city", "countryId", "birthDate", "mandateId",
  "civilStatus", "languageId", "language", "bname",
  "bfirstName", "bstreet", "bzip", "bcity", "bcountryId"
];

export const StyledGrid = styled(Grid)`
  margin: 10px !important;
  margin-top: 0 !important;
`;

export interface FieldProps extends FieldRenderProps, DropdownProps {
}

export enum FieldType {
  INPUT = "input",
  SELECT = "select",
  CHECKBOX = "checkBox",
  DATEPICKER = "datePicker",
  RADIOBUTTON = "radioButton"
}

export const getFieldType = (field: string): string => {

  let type: string = FieldType.INPUT;
  Object.keys(FIELDS).forEach(key => {
    if (FIELDS[key].includes(field)) {
      type = key;
    }
  });

  return type;
};

export const requiredImpl = (
    value: string,
    allValues: Partial<UpsertPatientDto>,
    field: string): string | undefined => {

  if (!CONDITIONAL_FIELDS.includes(field)) {
    return required(value);
  } else if (allValues.separateBill) {
    return required(value);
  }
};

export const sortZipData = (zipData: Array<IndexedZipData>, orderBy: ZipDataOrderBy) => {
  if (zipData) {
    if (orderBy === ZipDataOrderBy.ZIP) {
      return zipData.sort((a, b) => (a.zip > b.zip) ? 1 : ((b.zip > a.zip) ? -1 : 0));
    } else {
      return zipData.sort((a, b) => (a.city > b.city) ? 1 : ((b.city > a.city) ? -1 : 0));
    }
  }

  return [];
}
